import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import axios from 'axios';
import { Elements } from 'react-stripe-elements';
import IdleTimer from 'react-idle-timer';

import baseUrl from '../../utils/baseUrl';

import connect from '../../utils/connect';

import Splitter from './block/splitter';
import ContentBlock from './block/content';
import ConfirmDialog from  '../form/confirm';
import Spinner from '../svg/spinner';

import Step1 from './caseCreate/step1';
import Step2 from './caseCreate/step2';
import Step3 from './caseCreate/step3';
import Step4 from './caseCreate/step4';
import InactiveModal from './popup';

import translate from '../../utils/translate';

import { redirectToAccountIfNoProfile } from '../../utils/authorization';

const pingURL = baseUrl + '/api/account/refresh';

const CASE_STEP0 = 0;
const CASE_STEP1 = 1;
const CASE_STEP2 = 2;
const CASE_STEP3 = 3;
const CASE_STEP4 = 4;

import css from './caseCreate.scss';

class AccountCaseCreate extends Component {
	static propTypes = {
		dispatch: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		const CLEAR_SESSION_PATH = `${baseUrl}/api/account/projects/create`;
		axios.get(CLEAR_SESSION_PATH).then(() => {}).catch(() => {});

		this.idleTimer = null;
		this.handleOnIdle = this.handleOnIdle.bind(this);
		this.hideModal = this.hideModal.bind(this);
		this.handleInactive = this.handleInactive.bind(this);

		// http://fwa.test:3000/account/profile/projects/create/

		this.state = {
			skipPayment: !!(props.users.profile && props.users.profile.hasFreeSubmission),
			waiting: false,
			complete: false,
			step: props.router.location.query.step ? (parseInt(props.router.location.query.step, 10) ? CASE_STEP1 : CASE_STEP0) : CASE_STEP0,
			customerInfo: {},
			slug: '',
			showTimeoutModal: false,
		};
	}

	render() {
		return (
			<div className='account-process'>
				<IdleTimer
					ref={ref => { this.idleTimer = ref; }}
					timeout={1000 * 60 * 55}
					onIdle={this.handleOnIdle}
					debounce={250}
					events={[]}
				/>
				<Helmet title='The FWA - Account - Submit Project' />

				<InactiveModal
					show={this.state.showTimeoutModal}
					handleClose={this.hideModal}
					handleInactive={this.handleInactive}
				/>

				<ContentBlock title=''>
					<div className='account-process__title-area'>
						<strong>{translate('account/casecreate/head')}</strong><br />
						{translate('account/casecreate/head2')}
					</div>
				</ContentBlock>

				<ContentBlock title={<span dangerouslySetInnerHTML={{ __html: translate('account/casecreate/introHead', true, true) }}></span>} className='account-block-content--small-aside'>
					<div className='account-process__description-area123123 span5 span100p-tablet span100p-mobile' dangerouslySetInnerHTML={{ __html: translate('account/casecreate/intro', true) }}>
					</div>
				</ContentBlock>

				<ContentBlock className='pixel-pattern pixel-pattern--01'>
					<div className='account-process__button-area'>
						{(this.state.step === CASE_STEP0) && (
							<button className='button--dark' onClick={() => this.start()}>{translate('account/casecreate/startButton')}</button>
						)}
						<span className='account-process__button-area__button-desc'><span className='hide-mobile'>{translate('account/casecreate/startText')}</span> {translate('account/casecreate/startTextPrice')}</span>
					</div>
				</ContentBlock>

				<Step1
					dispatch={this.props.dispatch}
					activeStep={this.state.step}
					goToStep={() => this.goToStep(CASE_STEP1)}
					goForward={() => this.goForward(this.state)}
					onSubmit={(pr, st) => this.onSubmit(pr, st)}
					user={this.props.users}
				/>
				<Step2
					dispatch={this.props.dispatch}
					activeStep={this.state.step}
					skipPayment={this.state.skipPayment}
					goToStep={() => this.goToStep(CASE_STEP2)}
					goForward={() => this.goForward(this.state)}
					onSubmit={(pr, st) => this.onSubmit(pr, st)}
					skipToEnd={(st) => this.goToStep(CASE_STEP4, st)}
				/>

				<Elements>
					<Step3
						dispatch={this.props.dispatch}
						activeStep={this.state.step}
						customerInfo={this.state.customerInfo}
						goToStep={() => this.goToStep(CASE_STEP3)}
						goForward={() => this.goForward(this.state)}
						onSubmit={(pr, st) => this.onSubmit(pr, st)}
					/>
				</Elements>
				<Step4
					dispatch={this.props.dispatch}
					activeStep={this.state.step}
					goToStep={() => this.goToStep(CASE_STEP4)}
					goForward={() => this.goForward(this.state)}
					onSubmit={(pr) => this.onComplete(pr)}
					slug={this.state.slug}
				/>

			</div>
		);
	}

	showModal() {
		this.setState({
			showTimeoutModal: true,
		});
	}

	hideModal() {
		this.resetTimer();
		this.pingServer();
		this.setState({
			showTimeoutModal: false,
		});
	}

	handleOnIdle(event) {
		this.showModal();
	}

	resetTimer() {
		this.idleTimer.reset();
	}

	handleInactive() {
		const { history: { push }, dispatch } = this.props;
		dispatch(push('/'));
	}

	pingServer() {
		axios.get(pingURL);
	}

	start() {
		if (this.state.step === CASE_STEP0) {
			this.setState({
				...this.state,
				step: CASE_STEP1,
			});
		}
	}

	onSubmit(promise, addedState = {}) {
		promise.then((res) => {
			let newState = {
				...this.state,
				...addedState,
			};

			this.goForward(newState);
		}).catch(() => {});
	}

	onComplete(promise) {
		promise.then((res) => {
			this.setState({
				...this.state,
				complete: true,
			});
		}).catch(() => {});
	}

	goForward(state) {
		let nextStep = (state.step + 1);

		if (nextStep === CASE_STEP3 && this.state.skipPayment) {
			nextStep++;
		}

		if (nextStep > CASE_STEP4) {
			return false;
		}

		if (nextStep < state.step) {
			return false;
		}
		this.setState({
			...state,
			step: nextStep,
		});
	}

	goBackwards() {
		let prevStep = this.state.step - 1;
		if (prevStep < CASE_STEP0) {
			return false;
		}

		this.setState({
			...this.state,
			step: prevStep,
		});
	}

	goToStep(step, addedState = {}) {
		let minStep = CASE_STEP0;
		let maxStep = CASE_STEP4;
		if (!(step >= minStep && step <= maxStep)) {
			return false;
		}

		this.setState({
			...this.state,
			...addedState,
			step: step,
		});
	}

	cycleSteps() {
		let nextStep = (this.state.step + 1) % 5;
		this.setState({
			...this.state,
			step: nextStep,
		});
	}

	setWaiting(state) {
		this.setState({ ...this.state, waiting: state });
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}
}

export default connect(AccountCaseCreate);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/caseCreate.js
 **/